"use client";

import { usePathname } from "next/navigation";
import { i18n, type Locale } from "@/i18n-config";

const translations: Record<string, string> = {
  ru: "русский",
  kz: "қазақша",
};

export default function LocaleSwitcher() {
  const pathName = usePathname();
  const redirectedPathName = (locale: Locale) => {
    const clearPath = pathName.replace("/ru", "");

    if (locale === "ru") {
      return `/ru${clearPath}`;
    }
    if (locale === "kz") {
      return clearPath.length ? clearPath : "/";
    }
  };

  return (
    <ul className="uk-nav uk-dropdown-nav">
      {i18n.locales.map((locale) => {
        return (
          <li key={locale}>
            <a href={redirectedPathName(locale)}>
              <div className="bag-lang">{locale.toUpperCase()}</div>
              {translations[locale]}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
